import styled from 'styled-components'

export const CheckBoxContainer = styled.div`
  margin-top: 1.6rem;
`
